<div class="checkbox-toggle" [formGroup]="inputFormGroup" *ngIf="!withOutFrmGrp" >
    <div *ngIf="LabelText">
        <label> {{LabelText}}</label>
    </div>
    <fieldset [id]="rxID + 'f'" [disabled]="isDisabled">
        <input
            type="checkbox"
            class="toggle-input"
            [formControl]="inputFormGroup.get(custContrlName)"
            [id] = "inputFormGroup?.get(custContrlName)?.value ? rxID : rxID+1"
            [name] = "rxID"
            appCustomTooltip="{{titleMsg}}"
            [(ngModel)]="isChecked"
            [appAutofocus]="autoFocus"
            (keydown) = "!isDisabled && onKeyDownEvent($event)"
            (keyup.shift.tab)="!isDisabled && onShiftTabbingEvent($event)"
            (click)="!isDisabled && changeValue($event)"
        /><label class="toggle-label" [attr.for]="inputFormGroup?.get(custContrlName)?.value ? rxID : rxID+1"></label>
    </fieldset>
</div>
<div class="checkbox-toggle" *ngIf="withOutFrmGrp" >
    <input
    type="checkbox"
    class="toggle-input"
    [id] = "rxID"
    [name] = "rxID"
    appCustomTooltip="{{titleMsg}}"
    [(ngModel)]="isChecked"
    [appAutofocus]="autoFocus" 
    (keydown) = "!isDisabled && onKeyDownEvent($event)"
    (keyup.shift.tab)="!isDisabled && onShiftTabbingEvent($event)"
    (change) = "!isDisabled && changeValue($event)"
    /><label class="toggle-label" [attr.for]="rxID"></label>
</div>
